function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOutline143X143Px = function SvgOutline143X143Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 143 143",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m86.7 7.5 49.5 52.4c7.2 7.6 6.9 19.7-.8 26.9L83 136.2c-7.6 7.2-19.7 6.9-26.9-.8L6.7 83c-7.2-7.6-6.9-19.7.8-26.9L59.8 6.7c7.7-7.2 19.7-6.9 26.9.8z",
    style: {
      fill: "none",
      stroke: "#e5e5e5",
      strokeWidth: 2
    }
  }));
};
export default SvgOutline143X143Px;